export interface DocumentosGeneralesModels {
  tipo_documento: string;
  descripcion: string;
  activo: boolean;
  documentacion: Array<DocumentosGeneralesModel>;
  editar: boolean;
  filename: string;
  url_documento: string;
  tipo_documento_file: string;
  openModalViewer: boolean;
  index: number;
}

export interface DocumentosGeneralesModel {
  index: number;
  nombre: string;
  tipo_documento: string;
  descripcion: string;
  url_documento: string;
  activo: boolean;
}

export const initialValuesDocumentosGenerales = {
  nombre: "",
  tipo_documento: "",
  descripcion: "",
  activo: false,
  documentacion: [],
  editar: false,
  pdf: "",
  namepdf: "",
  file: [],
  filename: "",
  tipo_documento_file: "",
  url_documento: "",
  openModalViewer: false,
  index: 0,
};

export const initialValuesDocumentosGeneralesModel = {
  index: 0,
  nombre: "",
  tipo_documento: "",
  descripcion: "",
  url_documento: "",
  activo: false,
};
